module.exports = __webpack_public_path__ + "static/onmymind_bn_img@2x-e721cd689b419df0f549ed28aaef4c2c.png";